// extracted by mini-css-extract-plugin
module.exports = {"horizontal-ad":"organism1-m__horizontal-ad__2W4I2","four-col-story":"organism1-m__four-col-story__1ozvJ"};